import { BigFloat } from '@1inch-community/core/math';
import { JsonParser } from '@1inch-community/core/storage';
import { startWith, Subject, switchMap } from 'rxjs';
import { isTokensEqual } from '../tokens';
import { TokenContext } from './token-context';
export class PairHolder {
    constructor(applicationContext) {
        this.applicationContext = applicationContext;
        this.source = new TokenContext();
        this.destination = new TokenContext();
        this.pairChance$ = new Subject();
        this.restorePair();
    }
    restorePair() {
        this.restoreToken('source');
        this.restoreToken('destination');
    }
    switchPair() {
        const { source, destination } = this;
        this.source = destination;
        this.destination = source;
        this.updateTokenStore('source');
        this.updateTokenStore('destination');
        this.pairChance$.next();
    }
    setPair(pair) {
        this.setTokenInner(pair.source, 'source');
        this.setTokenInner(pair.destination, 'destination');
        this.pairChance$.next();
    }
    setToken(token, tokenType) {
        if (tokenType === 'source' && token !== null) {
            const destinationTokenSnap = this.destination.getSnapshot();
            if (destinationTokenSnap.token !== null && isTokensEqual(token, destinationTokenSnap.token)) {
                return this.switchPair();
            }
        }
        if (tokenType === 'destination' && token !== null) {
            const sourceTokenSnap = this.source.getSnapshot();
            if (sourceTokenSnap.token !== null && isTokensEqual(token, sourceTokenSnap.token)) {
                return this.switchPair();
            }
        }
        this.setTokenInner(token, tokenType);
    }
    setAmount(tokenType, value) {
        this.getTokenContext(tokenType).setAmount(value);
        this.updateTokenStore(tokenType);
    }
    streamSnapshot(tokenType) {
        return this.pairChance$.pipe(startWith(null), switchMap(() => this.getTokenContext(tokenType).streamSnapshot()));
    }
    getSnapshot(tokenType) {
        return this.getTokenContext(tokenType).getSnapshot();
    }
    setTokenInner(token, tokenType) {
        this.getTokenContext(tokenType).setToken(token);
        this.updateTokenStore(tokenType);
    }
    getTokenContext(tokenType) {
        if (tokenType === 'source') {
            return this.source;
        }
        if (tokenType === 'destination') {
            return this.destination;
        }
        throw new Error(`invalid token type ${tokenType}`);
    }
    updateTokenStore(tokenType) {
        const tokenContext = this.getTokenContext(tokenType);
        const snapshot = tokenContext.getSnapshot();
        if (snapshot.token !== null) {
            const { symbol, address, chainId, name, decimals } = snapshot.token;
            const amount = snapshot.amount;
            const jsonAmount = amount?.toJSON();
            this.applicationContext.storage.set(this.tokenStoreKey(tokenType), {
                symbol,
                address,
                chainId,
                name,
                decimals,
                amount: jsonAmount,
            });
        }
    }
    restoreToken(tokenType) {
        const tokenContext = this.getTokenContext(tokenType);
        const token = this.applicationContext.storage.get(this.tokenStoreKey(tokenType), JsonParser);
        if (token !== null) {
            const amount = BigFloat.isBigFloat(token.amount)
                ? BigFloat.parseJSON(token.amount)
                : BigFloat.zero();
            tokenContext.setToken(token);
            tokenContext.setAmount(amount);
        }
        // if (amount !== null) {
        //   tokenContext.setAmount(BigInt())
        // }
    }
    tokenStoreKey(tokenType) {
        return `token_${tokenType}_v2`;
    }
}
//# sourceMappingURL=pair-holder.js.map